import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { CompanyType } from '../../../schemas/company-type.schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { applicationRoleSchema } from '../schemas/application-role.schema';

/**
 * Retrieves the roles per account type
 * @param accountType Account's Company Type
 * @returns Array of roles per account type
 */
export function getRoles(this: unknown, accountType: CompanyType) {
  const params = new URLSearchParams([['accountType', accountType]]);

  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).rolesUrl}?${params.toString()}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(z.array(applicationRoleSchema)));
}
